module.exports = __webpack_public_path__ + "img/installDesktop.e81dee57.png";